import React from "react";
import { css, StyleSheet } from "aphrodite";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import QrDialogContent from '../../components/QrDialogContent';
import QRCode from "qrcode";

import { ApiHelper } from "../../common/helpers/ApiHelper";
import { Helper } from "../../common/helpers/Helper";
import { UiHelper } from "../../common/helpers/UiHelper";
import { AppStyles } from "../../styles/AppTheme";
import { AppConfig } from "../../AppConfig";
import { CustomCbDefsStyles } from "../../styles/CustomStyles";
import { BaseEntityPageSlixta } from "../../components/BaseEntityPageSlixta";
import { Controller } from "../../common/Controller";
import { SearchBar } from "../../common/components/SearchBar";
import { PageDialog } from "../../common/components/PageDialog";
import { AppButton } from "../../common/components/AppButton";
import { AppTheme } from "../../styles/AppTheme";
export class Pages extends BaseEntityPageSlixta {
  constructor(props) {
    super(props, { assetPicker: true });
    this.pageTitle = Helper.getString("pages");
    this.orgId = this.props.match.params.orgId || "PRODUCT";
    this.breadCrumbs = [
      { title: Helper.getString("home"), to: this.baseRoute() },
      { title: this.pageTitle },
    ];
    this.toFetch = [
      {
        method: "GET", paths: ["pages"],queryParams: { orgId: this.orgId,
          pb: "fieldDef,fieldDefPageFulfilment,fieldDefSEO,fieldDefPageAdvanced",},},
      { method: "GET", paths: ["cbdefs"], queryParams: { orgId: this.orgId } },
      { method: "GET",paths: ["miscs", "cotypes"], queryParams: { orgId: this.orgId },},
      // { key: 'lists', method: 'GET', paths: ['lists'], queryParams: { orgId: this.orgId } },
    ];
    this.tableHeadersMap = {
      Index: (current) => {
        return current.__index + 1;
      },
      Info: (current) => {
        const v = { ...current };
        if (current.coTypeId) {
          v.badge = "Multipage";
          v.slug = v.slug ? v.slug + "/<path>" : v.slug;
        }
        return UiHelper.itemDetails(v);
      },
      Status: (current) => UiHelper.itemStatusContainer(current),
    };
    this.tableHeaders = Object.keys(this.tableHeadersMap);
    this.apiData = {
      orgId: this.orgId,
    };
    // this.conf = {
    //   previewPath: '/' // TODO: Was colliding with headerActions
    // }
    this.pageKey = "pages";
    this.headerActions = [
      {
        label: "Page",
        onClick: () => this.openModalForAdd(),
      },
    ];
    if (Controller.get().roleHelper().isProductSU()) {
      this.headerActions.push({
        label: "Multipage",
        // icon: 'view_stream',
        onClick: () => this.openModalForCoTypePageAdd(),
      });
    }
    this.state = {
      ...this.state,
      qrDialogOpen: false,
      qrCurrentPage: null,
      utmCampaign: "",
      qrDataUrl: null,
      qrShowAdvanced: false,
      utmOptions:{
        utm_source: "",
        utm_medium: "",
        utm_content: "",
        utm_term: "",
        utm_id: ""
      }
    };
  }
  buildFullLink(page, campaign, options = {}) {
    const base = page && page.slug ? `${this.webappSsrLink}/${page.slug}` : "";
    if (!base) return base;
    
    const params = new URLSearchParams();
    if (campaign) params.append("utm_campaign", campaign);
    if (options.utm_source) params.append("utm_source", options.utm_source);
    if (options.utm_medium) params.append("utm_medium", options.utm_medium);
    if (options.utm_content) params.append("utm_content", options.utm_content);
    if (options.utm_term) params.append("utm_term", options.utm_term);
    if (options.utm_id) params.append("utm_id", options.utm_id);

    const queryString = params.toString();
    return queryString ? `${base}?${queryString}` : base;
  }

  async generateQr(url) {
    if (!url) {
      this.setState({ qrDataUrl: null });
      return;
    }
    try {
      const dataUrl = await QRCode.toDataURL(url, {
        width: 300,
        margin: 2,
        color: { dark: "#000000", light: "#00000000" }, // transparent background
        errorCorrectionLevel: "H",
      });
      this.setState({ qrDataUrl: dataUrl });
    } catch (e) {
      console.error("QR generation failed:", e);
      this.setState({ qrDataUrl: null });
    }
  }
  regenerateQr() {
    const url = this.buildFullLink(
      this.state.qrCurrentPage,
      this.state.utmCampaign,
      this.state.utmOptions
    );
    this.generateQr(url);
  }
  openQrDialog(current) {
  const url = this.buildFullLink(current, "", {});
  this.setState(
    {
      qrDialogOpen: true,
      qrCurrentPage: current,
      utmCampaign: "",
      utmOptions: {
        utm_source: "",
        utm_medium: "",
        utm_content: "",
        utm_term: "",
        utm_id:""
      },
      qrShowAdvanced: false,
      qrDataUrl: null,
    },
    () => this.generateQr(url),
  );
}
  closeQrDialog() {
    this.setState({
      qrDialogOpen: false,
      qrCurrentPage: null,
      qrDataUrl: null,
      utmCampaign: "",
      utmOptions: {
        utm_source: "",
        utm_medium: "",
        utm_content: "",
        utm_term: "",
        utm_id: ""
      }
    });
  }
  handleUtmChange(fieldName, val) {
    if (fieldName === 'utmCampaign') {
      this.setState({ utmCampaign: val }, () => this.regenerateQr());
    } else {
      this.setState(
        prev => ({
          utmOptions: { ...prev.utmOptions, [fieldName]: val }
        }),
        () => this.regenerateQr());
    }
  }
  downloadQr() {
    const { qrCurrentPage } = this.state;
    if (!qrCurrentPage) return;

    const url = this.buildFullLink(
      qrCurrentPage,
      this.state.utmCampaign,
      this.state.utmOptions
    );
    QRCode.toDataURL(url, {
      width: 1920,
      margin: 2,
      color: { dark: "#000000", light: "#00000000" },
      errorCorrectionLevel: "H",
    }).then((dataUrl) => {
        const a = document.createElement("a");
        a.href = dataUrl;
        a.download =
          (qrCurrentPage && qrCurrentPage.slug ? qrCurrentPage.slug : "qr") +
          "-qr.png";
        a.click();
      }).catch((e) => console.error("QR download generation failed:", e));
  }

  onFetchSuccess(results) {
    this.fieldDefSEO = results[0].fieldDefSEO;
    this.fieldDefPageAdvanced = results[0].fieldDefPageAdvanced;
    this.fieldDefCoTypePage = {
      steps: [
        {
          fields: results[0].fieldDef.steps[0].fields.filter((i) =>
            Helper.inArray(
              ["title", "slug", "state", "includeInSitemap", "coTypeId"], i.key,),),},
      ],
    };
    this.fieldDef = {
      steps: [
        {fields: results[0].fieldDef.steps[0].fields.filter((i) => !Helper.inArray(["coTypeId"], i.key), ), },
      ],
    };
    const advancedKeys = ["descr", "ctaLabel", "link", "bannerType"];
    this.fieldDef.steps[0].fields.forEach((field) => {
      if (advancedKeys.includes(field.key)) {
        field.advanced = true;
      }
      if (field.key === "descr") {
        field.label = field.label + " (deprecated)";
      }
      if (field.key === "link") {
        field.placement = "right";
      }
    });
    this.fieldDefPageFulfilment = results[0].fieldDefPageFulfilment;

    const cbdefData = results[1];
    cbdefData.items.forEach((i) => (i.id = i.slug));
    cbdefData.items.push({ id: "benefits", title: "Benefits" });
    cbdefData.items.push({ id: "testimonials", title: "Testimonials" });
    cbdefData.items.push({ id: "faqs", title: "FAQs" });
    UiHelper.populateOptions(this.fieldDef, cbdefData, "entities");

    const coTypesData = results[2];
    this.webappSsrLink = coTypesData.__appConfig && coTypesData.__appConfig.WEBAPP_SSR_LINK;
    UiHelper.populateOptions(this.fieldDefCoTypePage, coTypesData, "coTypeId");
    this.setState({
      items: results[0].items,
      masterPageList: results[0].items,
    });
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return "";
    return this.tableHeadersMap[this.tableHeaders[index]](current);
  }

  onAdd() {
    this.setState({
      apiMethod: "POST",
      apiEndPoint: ApiHelper.makeUrlPath(["pages"], {}),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: "PUT",
      apiEndPoint: ApiHelper.makeUrlPath(["pages", current.id], {}),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: "DELETE",
      apiEndPoint: ApiHelper.makeUrlPath(["pages", current.id], {}),
    });
  }

  openModalForFulfilmentEdit(current) {
    super.openModalForEdit(current, this.fieldDefPageFulfilment);
  }

  openModalForCoTypePageAdd() {
    super.openModalForAdd(this.fieldDefCoTypePage);
  }

  openModalForCoTypePageEdit(current) {
    super.openModalForEdit(current, this.fieldDefCoTypePage);
  }

  openModalForDuplicatePage(current) {
    console.log("edit:", current);
    this.formDefinition = pageActionsFieldDef;
    this.formDefinition.formType = "edit";
    Helper.populateFormDefinitionValues(this.formDefinition, current);
    this.setState({
      apiMethod: "POST",
      apiEndPoint: ApiHelper.makeUrlPath(["miscs", "page-duplication"], {
        orgId: this.orgId,
      }),
      apiData: {
        pageId: current.id,
      },
      modalOpen: true,
    });
  }

  openModalForAdvanced(current) {
    console.log("openModalForAdvanced:", current);
    this.formDefinition = this.fieldDefPageAdvanced;
    this.formDefinition.formType = "edit";
    Helper.populateFormDefinitionValues(this.formDefinition, current);
    this.onEdit(current);
    this.setState({
      modalOpen: true,
    });
  }

  onMenuItems = (current) => {
    const menuItems = [];
    const actions = [];

    menuItems.push(
      {
        current: current,
        key: current.id + "editTT",
        action: () => {
          current.coTypeId
            ? this.openModalForCoTypePageEdit(current)
            : this.openModalForEdit(current);
        },
        title: Helper.getString("edit"),
        icon: "edit",
      },
      {
        current: current,
        key: current.id + "SEOTT",
        action: () => this.openModalForSEO(current),
        title: Helper.getString("SEO"),
        icon: "content_paste_search",
      },
      {
        current: current,
        key: current.id + "clone",
        action: () => {
          this.openModalForDuplicatePage(current);
        },
        title: Helper.getString("clonePage"),
        icon: "copy_all",
      },
      {
        current: current,
        key: current.id + "adv",
        action: () => {
          this.openModalForAdvanced(current);
        },
        title: Helper.getString("advanced"),
        icon: "settings_suggest",
      },
      {
        current: current,
        key: current.id + "deleteTT",
        action: () => {
          this.openModalForDelete(current);
        },
        title: Helper.getString("delete"),
        icon: "delete",
      },
    );

    for (const mi of menuItems) {
      actions.push(UiHelper.actionButton(mi));
    }

    return actions;
  };

  onActions = (current) => {
    const actions = [];
    actions.push(
      <Tooltip title="Generate QR Code" placement="top-start" key={current.id + "-qr"} >
        <span className={css(AppStyles.entityTableLinkIcon,Styles.entityTableLinkIcon,Styles.qrIconWrapper, )} onClick={() => this.openQrDialog(current)}>
          <i className="material-icons-outlined">qr_code_2</i>
        </span>
      </Tooltip>,
    );
    actions.push(
      <Link to={this.baseRoute() + "/pages/" + current.id + "/blocks"} key={current.id + "-cbdefs"} className={css(Styles.anchorTag)}>
        <Tooltip title={Helper.getString("pageDetails")} placement="top-start">
          <span className={css(AppStyles.entityTableLinkIcon,Styles.entityTableLinkIcon,)}>
            <i className="material-icons-outlined">arrow_forward_ios</i>
          </span>
        </Tooltip>
      </Link>,
    );
    if (current.coTypeId) {
      actions.push(
        <Link
          to={this.baseRoute() + "/pages/" + current.id + "/cotypeblocks"}
          key={current.id + "-cotypeblocks"}
          className={css(Styles.anchorTag)}
        >
          <Tooltip title={Helper.getString("cotypeblocks-widgets")} placement="top-start" >
            <span className={css(AppStyles.entityTableLinkIcon, Styles.entityTableLinkIcon,)}>
              <i className="material-icons-outlined">ballot</i>
            </span>
          </Tooltip>
        </Link>
      );
    }
    return actions;
  };

  renderAboveTable() {
    return (
      <SearchBar
        hint={Helper.getString("pageSearchHint")}
        onSearch={this.onSearch.bind(this)}
        onClearSearch={this.clearSearch.bind(this)} 
        searchText={this.state.searchText}
        searchButtonLabel="Filter"
        clearSearchLabel="Clear Search"
        autoRefresh={true}
        debounceDuration={1}
        autoFocus={true}
      >
      </SearchBar>
    );
  }

  onSearch(searchText) {
    if (!searchText) {
      this.setState({
        items: this.state.masterPageList,
      });
      return;
    }
    const search = searchText.toLowerCase();
    const pageList = [...this.state.masterPageList];

    const filteredPageList = pageList.filter((page) => {
      return (
        (page.title && page.title.toLowerCase().includes(search)) ||
        (page.slug && page.slug.toLowerCase().includes(search))
      );
    });

    this.setState({
      items: filteredPageList,
    });
  }
  clearSearch() {
    this.setState({
      items: this.state.masterPageList,
    });
  }

  renderQrDialog() {
    return (
      <PageDialog
        isOpen={this.state.qrDialogOpen}
        title="Generate QR Code"
        onClosed={() => this.closeQrDialog()}
        fullWidth={true}
        maxWidth="md"
        PageComponent={QrDialogContent}
        PageComponentProps={{
          page: this.state.qrCurrentPage,
          utmCampaign: this.state.utmCampaign,
          utmOptions: this.state.utmOptions,
          qrDataUrl: this.state.qrDataUrl,
          qrShowAdvanced: this.state.qrShowAdvanced,
          inputLabel: 'UTM Campaign',
          inputHint: '(optional)',
          showPrimaryInput: true,
          showAdvanced: true,
          showCopyLink: false,
          onToggleAdvanced: () => this.setState({ qrShowAdvanced: !this.state.qrShowAdvanced }),
          onUtmChange: (fieldName, val) => this.handleUtmChange(fieldName, val),
          onDownload: () => this.downloadQr(),
          buildFullLink: (page, campaign, options) => this.buildFullLink(page, campaign, options),
        }}
      />
    );
  }
  readyView() {
    const parentView = super.readyView();
    return (
      <>
        {parentView}
        {this.renderQrDialog()}
      </>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE
  ? CustomCbDefsStyles
  : StyleSheet.create({
    spanValue: {
      fontSize: 12,
    },
  });
const pageActionsFieldDef = {
  formType: "edit",
  steps: [
    {
      fields: [
        {
          hint: "Action",
          key: "action",
          label: "Action",
          type: "radio",
          options: [{ key: "CLONE_PAGE", label: "CLONE_PAGE" }],
          defaultValue: "CLONE_PAGE",
          placement: "left",
          // eslint-disable-next-line camelcase
          v_required: { value: true, err: "Action required" },
        },
      ],
    },
  ],
};
